import { shallowInitState } from '../constants/defaults.js';
import { FShallowGraph, FShallowNode } from '../types/index.js';

import {
  GraphActionType,
  GraphAddAction,
  GraphInitAction,
  GraphLoadAction,
  GraphRemoveAction,
  GraphSetNameAction,
  GraphSetSpaceAction,
  GraphUpdateAction,
} from './types.js';

/**
 * Creates an action to initialize the graph
 */
export const createInitAction = (initialState: Partial<FShallowGraph>): GraphInitAction => ({
  type: GraphActionType.Init,
  payload: {
    ...shallowInitState,
    ...initialState,
  },
});

/**
 * Create load action to replace the current state with the given state
 */
export const createLoadAction = (state: FShallowGraph): GraphLoadAction => ({
  type: GraphActionType.Load,
  payload: state,
});

/**
 * Creates an action to add a node to the graph
 */
export const createAddNodeAction = (selector: string, node: FShallowNode): GraphAddAction => ({
  type: GraphActionType.Add,
  payload: { selector, node },
});

/**
 * Creates an action to update a property of a node
 */
export const createUpdateNodeAction = (
  selector: string,
  path: string,
  value: unknown
): GraphUpdateAction => ({
  type: GraphActionType.Update,
  payload: {
    selector,
    path,
    value,
  },
});

export function createNodeAction(
  type: GraphActionType.Add,
  selector: string,
  node: FShallowNode
): GraphAddAction;
export function createNodeAction(
  type: GraphActionType.Update,
  selector: string,
  path: string,
  value: unknown
): GraphUpdateAction;

export function createNodeAction(type: GraphActionType.Remove, selector: string): GraphRemoveAction;
export function createNodeAction(type: GraphActionType, ...rest: any[]) {
  switch (type) {
    case GraphActionType.Add:
      return createAddNodeAction(...(rest as Parameters<typeof createAddNodeAction>));
    case GraphActionType.Update:
      return createUpdateNodeAction(...(rest as Parameters<typeof createUpdateNodeAction>));
    case GraphActionType.Remove:
      return createRemoveNodeAction(...(rest as Parameters<typeof createRemoveNodeAction>));
    default:
      throw new Error(`Unknown action type: ${type}`);
  }
}

export const createRemoveNodeAction = (selector: string): GraphRemoveAction => ({
  type: GraphActionType.Remove,
  payload: {
    selector,
  },
});

/**
 * Creates an action to set the name of the graph
 */
export const createSetName = (name: string): GraphSetNameAction => ({
  type: GraphActionType.SetName,
  payload: { name },
});

/**
 * Creates an action to set the space of the graph
 */
export const createSetSpace = (id: number): GraphSetSpaceAction => ({
  type: GraphActionType.SetSpace,
  payload: { id },
});
